import * as Yup from "yup";

export const categoryValidationSchema = Yup.object().shape({
  Title: Yup.string()
    .required("Title is required")
    .min(2, "Title must be at least 2 characters"),
  IsActive: Yup.boolean().required("Status is required"),
});
